import React from 'react';
import PropTypes from 'prop-types';

// Components
import ZoneCollectionLayer from 'mapping/layers/ZoneCollectionLayer';

// Utils
import { styleMethods } from 'dataviz/config/map';

const SoilComparisonLayer = ({
  zones,
  map
}) => (
  <ZoneCollectionLayer
    layerName='ssurgoOverlay'
    map={map}
    styleFunction={styleMethods.soil}
    zones={zones}
  />
);

SoilComparisonLayer.propTypes = {
  map: PropTypes.object, // Inserted by mapping/leaflet.
  zones: PropTypes.object.isRequired
};

export default SoilComparisonLayer;
